export function Flag({ code, className = "h-4 w-6" }) {
  if (!code) return null;
  return (
    <img
      src={`https://flagcdn.com/w80/${code.toLowerCase()}.png`}
      srcSet={`https://flagcdn.com/w160/${code.toLowerCase()}.png 2x`}
      alt=""
      className={className}
      loading="lazy"
    />
  );
}
